import React, {Component} from 'react';

import Text from 'components/Text';
import EasyTooltip from 'components/EasyTooltip';

class OverflowTooltip extends Component {
	constructor(props) {
		super(props);

		this.state = {
			hasOverflow: false,
		};

		this.overflowRef = el => (this.overflowEl = el);
		this.checkOverflow = this.checkOverflow.bind(this);
	}

	checkOverflow() {
		let hasOverflow = false;
		if (this.overflowEl) {
			const {scrollWidth, offsetWidth} = this.overflowEl;
			hasOverflow = scrollWidth > offsetWidth;
		}
		this.setState({hasOverflow});
	}

	componentDidMount() {
		this.checkOverflow();
	}

	render() {
		const {children, content, refKey = 'ref', ...otherProps} = this.props;

		const {hasOverflow} = this.state;
		const tooltipContent = hasOverflow ? content : undefined;

		// Text-only children that don't have a wrapper element
		// get default "ellipsis" overflow styles
		if (typeof children === 'string') {
			return (
				<EasyTooltip
					content={tooltipContent}
					placement="top-start"
					{...otherProps}
				>
					<Text
						ref={this.overflowRef}
						overflow="ellipsis"
						display="block"
					>
						{children}
					</Text>
				</EasyTooltip>
			);
		}

		return (
			<EasyTooltip
				content={tooltipContent}
				placement="top-start"
				{...otherProps}
			>
				{React.cloneElement(React.Children.only(children), {
					[refKey]: this.overflowRef,
				})}
			</EasyTooltip>
		);
	}
}

export default OverflowTooltip;
